import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft, ShieldCheck } from 'lucide-react';
import LanguageSwitcher from '../components/LanguageSwitcher';

const PageHeader = () => {
  const { t } = useTranslation();

  return (
    <header className="fixed top-0 w-full bg-white z-50 border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between gap-6">
        <Link to="/" className="flex items-center flex-shrink-0">
          <img
            src="https://imgur.com/nYWIvWJ.png"
            alt="Nextcoders Logo"
            className="h-8"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = 'https://placehold.co/150x32/1f2937/ffffff?text=Nextcoders';
            }}
          />
        </Link>
        <div className="flex items-center gap-4">
          <LanguageSwitcher variant="compact" />
          <Link to="/nexbot-contact" className="text-gray-600 hover:text-[#141414] font-medium text-sm transition">
            Contacto
          </Link>
          <Link to="/nexbot" className="text-gray-600 hover:text-[#141414] font-medium text-sm transition">
            {t('nexbot.privacy.header_links.nexbot')}
          </Link>
          <Link to="/nexbot-eula" className="text-gray-600 hover:text-[#141414] font-medium text-sm transition">
            {t('nexbot.privacy.header_links.eula')}
          </Link>
        </div>
      </div>
    </header>
  );
};

const NexbotPrivacidadPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const sections = t('nexbot.privacy.sections', { returnObjects: true });

  return (
    <div className="min-h-screen bg-[#faf9f6] font-inter">
      <PageHeader />

      <main className="pt-32 pb-24 px-4 sm:px-6">
        <div className="max-w-4xl mx-auto">
          <button
            type="button"
            onClick={() => (window.history.length > 1 ? navigate(-1) : navigate('/nexbot'))}
            className="inline-flex items-center gap-2 text-gray-500 hover:text-[#141414] mb-8 transition font-medium"
          >
            <ArrowLeft size={16} />
            {t('nexbot.privacy.back')}
          </button>

          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-sm border border-gray-100">
            <div className="flex items-center gap-4 mb-8">
              <div className="p-3 bg-emerald-100 text-emerald-700 rounded-xl">
                <ShieldCheck size={28} />
              </div>
              <h1 className="text-3xl md:text-4xl font-bold text-[#2d2a26]">
                {t('nexbot.privacy.title')}
              </h1>
            </div>

            <div className="prose prose-emerald max-w-none text-gray-600 leading-relaxed">
              <p>
                <strong>{t('nexbot.privacy.updated_label')}</strong> {t('nexbot.privacy.updated_value')}
              </p>
              <p>{t('nexbot.privacy.intro_1')}</p>
              <p>{t('nexbot.privacy.intro_2')}</p>

              {sections.map((section) => (
                <div key={section.title}>
                  <h3 className="text-xl font-bold text-[#2d2a26] mt-8 mb-4">{section.title}</h3>
                  <p>
                    {section.isContact ? (
                      <>
                        {t('nexbot.privacy.contact_prefix')}{' '}
                        <Link to="/nexbot-contact" className="text-emerald-700 hover:text-emerald-800 font-semibold">
                          /nexbot-contact
                        </Link>{' '}
                        <span className="text-gray-500">| apps@nextcoders.work</span>
                      </>
                    ) : (
                      section.body
                    )}
                  </p>
                </div>
              ))}
            </div>

            <div className="mt-12 pt-8 border-t border-gray-100 flex gap-4">
              <Link to="/nexbot" className="px-6 py-3 bg-emerald-600 text-white rounded-xl font-semibold hover:bg-emerald-700 transition">
                {t('nexbot.privacy.back_to_nexbot')}
              </Link>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default NexbotPrivacidadPage;
